import Invoices from './invoices';
export default Invoices;
